import { observer } from "mobx-react";
import { useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  MetadataAdd,
  Metadataupdate,
  Partner_list
} from "../../api/api";
import crossCheck from "../../assets/images/crosscheck.png";
import activeIcon from "../../assets/images/schedule-active.png";
import check from "../../assets/images/star_checked.svg";
import DownArrowIcon from '../../assets/svg/Distribution/downArrow.svg';
import CloseIcon from '../../assets/svg/POSTER/close.svg';
import editIcon from '../../assets/svg/partitioncontent/edit.svg';
import uncheck from "../../assets/svg/partitioncontent/feavrate.svg";
import OpenfullIcon from '../../assets/svg/partitioncontent/open_in_full.svg';
import { ContentGroup } from "../../service/Constant";
import { permissionDetails } from "../../utility/localStoageData";
import { xmlData } from "../../utility/xmlData";
import DynamicMultiSelect from "../multiselect/MultiSelect";
import "./style.scss";
import TimePicker from "react-time-picker";

const CustomSingleSelect = ({ options, value, onChange, placeholder, disabled, displayKey = 'name', valueKey = 'id' }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const displayValue = value && typeof value === 'object' 
    ? value[displayKey] 
    : options?.find(opt => opt[valueKey] === value)?.[displayKey] || placeholder || 'Select...';

  const handleSelect = (option) => {
    onChange(option[valueKey]);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        background: 'transparent',
      }}
      ref={dropdownRef}
    >
      <div
        onClick={() => !disabled && setIsOpen(!isOpen)}
        style={{
          width: '100%',
          padding: '10px',
          color: '#fff',
          borderRadius: '4px',
          cursor: disabled ? 'not-allowed' : 'pointer',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          isolation: 'isolate',
          backgroundColor:'#1c1c1c',
          marginTop: '4px',
          fontSize:"16px"
        }}
        className="custom-single-select"
      >
        <span>{displayValue}</span>
        <span style={{ marginRight: '5px' }}>
          <img src={DownArrowIcon} alt="Dropdown"  width={"15px"}/>
        </span>
      </div>

      {isOpen && (
        <div
          style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            background: '#2E3033',
            // border: '1px solid #444',
            borderRadius: '0px 0px 4px 4px',
            // marginTop: '2px',
            zIndex: 10,
            maxHeight: '200px',
            overflowY: 'auto',
            isolation: 'isolate',
          }}
          className="custom-single-select-popup dropdownScroll"
        >
          {options?.map((option) => {
            const isSelected = value === option[valueKey];

            return (
              <label
                key={option[valueKey]}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '5px 10px',
                  color: '#fff',
                  cursor: 'pointer',
                  // borderBottom: '1px solid #444',
                  background: 'transparent',
                  fontSize:"16px",
                }}
                onClick={() => handleSelect(option)}
              >
                <div
                  style={{
                    width: '14px',
                    height: '14px',
                    borderRadius: '50%',
                    border: `2px solid ${isSelected ? '#E9E9E9' : '#606264'}`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '8px',
                  }}
                >
                  {isSelected && (
                    <div
                      style={{
                        width: '6px',
                        height: '6px',
                        borderRadius: '50%',
                        backgroundColor: '#E9E9E9',
                      }}
                    />
                  )}
                </div>
                {option[displayKey]}
              </label>
            );
          })}
        </div>
      )}
    </div>
  );
};

const Partitioncontent = observer(({
  videodata,
  closepartition,
  assetdetail,
  expandMetaView,
}) =>{
  // const [videodata, setVideodata] = useState(toJS(appStore.assetSignledata));
  const AssetPartnerDetail = JSON.parse(localStorage.getItem("AssetPartnerDetail"));
  const [metadata, setMetadata] = useState(videodata?.metadata || null);
  const state = useSelector((state) => state);
  const genre = state?.GenreList?.data;
  const language = state?.AudioLanguageList?.data;
  const Themes = state?.ThemesList?.data;
  const Category = state?.CategoriesList?.data;
  const Ratings = state?.MaturityList?.data;
  const Territorys = state?.CountryList?.data?.data;

  const [partnerOption, setPartnerOptions] = useState([]);
  const [territoryOption, setTerritoryOption] = useState([]);
  const [categoryOptions, setCategoryOption] = useState([]);
  const [languageList, setLanguageList] = useState([]);
  const [themeList, setThemeList] = useState([]);
  const [ratingList, setRatingList] = useState([]);
  const [gernreList, setGenreList] = useState([]);
  const [selectedCategoryIds, setSelectedCategoryIds] = useState([]);
  const [selectedThemeIds, setSelectedThemeIds] = useState([]);
  const [selectedLanguageIds, setSelectedLanguageIds] = useState([]);
  const [selectedGenreIds, setSelectedGenreIds] = useState([]);
  const [selectedTerritoryIds, setSelectedTerritoryIds] = useState([]);

  const [updatebtn, setupdatebtn] = useState(false);
  const [featurecheck, setFeaturecheck] = useState(false);
  const [partnerCode, setPartnerCode] = useState("");
  const [partnerName, setPartnerName] = useState("");
  const [programId, setProgramId] = useState("");
  const [title, setTitle] = useState("");
  const [programType, setProgramType] = useState("");
  const [duration, setDuration] = useState("");
  const [shortSynopsis, setShortSynopsis] = useState("");
  const [actors, setActors] = useState("");
  const [directors, setDirectors] = useState("");
  const [releaseDate, setReleaseDate] = useState(null);
  const [originalLanguage, setOriginalLanguage] = useState("");
  const [origin, setOrigin] = useState("");
  const [ratingvalue, setRating] = useState("");
  const [ratingsDescriptor, setRatingsDescriptor] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [contentGroup, setContentGroup] = useState("");
  const [permission, setpermission] = useState(null);
  const [editable, setEditable] = useState(true);

  useEffect(() => {
    if (videodata?.metadata != null) {
      setEditable(true);
      const newMetadata = videodata?.metadata;
      setMetadata(newMetadata);
      setFeaturecheck(newMetadata?.featured == null ? false : newMetadata?.featured);
      setPartnerCode(newMetadata?.partnerCode || "");
      setPartnerName(newMetadata?.partnerName || "");
      setProgramId(newMetadata?.programId || "");
      setTitle(newMetadata?.title || "");
      setProgramType(newMetadata?.programType || "");
      setDuration(newMetadata?.duration || "");
      setShortSynopsis(newMetadata?.shortSynopsis || "");
      setActors(newMetadata?.actors || "");
      setDirectors(newMetadata?.directors || "");
      setOriginalLanguage(newMetadata?.originalLanguage?.id || "");
      setOrigin(newMetadata?.origin || "");
      setRating(newMetadata?.ratings?.[0]?.id || "");
      setRatingsDescriptor(newMetadata?.ratingsDescriptor || "");
      const end = parseInt(newMetadata?.endDate, 10);
      const timestamp = parseInt(newMetadata?.startDate, 10);
      const startdate = !isNaN(timestamp) ? new Date(timestamp) : null;
      const enddate = !isNaN(end) ? new Date(end) : null;
      const redate = parseInt(newMetadata?.releaseDate, 10);
      const daterelease = !isNaN(redate) ? new Date(redate) : null;
      setReleaseDate(daterelease);
      setStartDate(startdate);
      setEndDate(enddate);
      setContentGroup(newMetadata?.contentGroup || "");
      setSelectedThemeIds(newMetadata?.themes?.map((obj) => obj.id) || []);
      setSelectedCategoryIds(newMetadata?.categories?.map((obj) => obj.id) || []);
      setSelectedLanguageIds(newMetadata?.audioLanguages?.map((obj) => obj.id) || []);
      setSelectedGenreIds(newMetadata?.genres?.map((obj) => obj.id) || []);
      setSelectedTerritoryIds(newMetadata?.territories?.map(obj => obj.id) || []);
    } else {
      setMetadata(null);
      setPartnerCode("");
      setPartnerName("");
      setProgramId("");
      setTitle("");
      setProgramType("");
      setDuration("");
      setShortSynopsis("");
      setActors("");
      setDirectors("");
      setFeaturecheck(false);
      setOriginalLanguage("");
      setOrigin("");
      setRating("");
      setRatingsDescriptor("");
      setReleaseDate(null);
      setStartDate(null);
      setEndDate(null);
      setContentGroup("");
      setSelectedThemeIds([]);
      setSelectedCategoryIds([]);
      setSelectedLanguageIds([]);
      setSelectedGenreIds([]);
      setSelectedTerritoryIds([]);
    }
  }, [videodata]);

  const handleDoneClick = () => {
    setupdatebtn(true);
    updatemetadata(videodata?.metadata?.id);
  };

  const featuredchecks = () => {
    if (!editable) {
      setFeaturecheck(!featurecheck);
    }
  };

  const formatReleaseDate = () => {
    const date = new Date(releaseDate);
    return date.getTime()
    // return `${date.getFullYear()}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getDate().toString().padStart(2, '0')}`;
  };

  const updatemetadata = async (id) => {
    let data = {
      ...(videodata?.metadata == null && { programId: videodata?.filename }),
      ...(videodata?.metadata == null && { partnerId: AssetPartnerDetail?.id }),
      title: title,
      programType: programType,
      duration: duration,
      shortSynopsis: shortSynopsis,
      actors: actors,
      directors: directors,
      releaseDate: releaseDate == null ? null : formatReleaseDate(),
      originalLanguageId: Number(originalLanguage),
      origin: origin,
      ratingIds: ratingvalue == null ? [] : [ratingvalue],
      ratingsDescriptor: ratingsDescriptor,
      territoryIds: selectedTerritoryIds,
      startDate: startDate == null ? "" : new Date(startDate).getTime(),
      endDate: endDate == null ? "" : new Date(endDate).getTime(),
      audioLanguageIds: selectedLanguageIds,
      themeIds: selectedThemeIds,
      categoryIds: selectedCategoryIds,
      genreIds: selectedGenreIds,
      contentGroup: contentGroup,
      featured: featurecheck,
    };

    if (title != "") {
      if (videodata?.metadata != null) {
        const metadata = await Metadataupdate(id, data);
        if (metadata?.data.status == true) {
          setEditable(true);
          toast.success("Metadata updated successfully", {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 5000,
          });
        } else {
          toast.error("Something went wrong, please try after sometime", {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 5000,
          });
        }
      } else {
        const addmetadata = await MetadataAdd(data);
        if (addmetadata?.data.status == true) {
          toast.success("Metadata added successfully", {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 5000,
          });
        } else {
          toast.error("Something went wrong, please try after sometime", {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 5000,
          });
        }
      }
      setupdatebtn(false);
      assetdetail();
    } else {
      toast.error("Title is required", {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 5000,
      });
      setupdatebtn(false);
    }
  };

  const getPermission = () => {
    let findEdit = permissionDetails();
    if (findEdit.includes("ASSET_MANAGEMENT_EDIT")) setpermission("edit");
    else if (findEdit.includes("ASSET_MANAGEMENT_READ")) setpermission("read");
    else setpermission(null);
  };

  useEffect(() => {
    getPermission();
    getPartnerList();
    setTerritoryOption(Territorys);
    setGenreList(genre);
    setLanguageList(language);
    setCategoryOption(Category);
    setThemeList(Themes);
    setRatingList(Ratings);
  }, []);

  const getPartnerList = async () => {
    const partnerData = await Partner_list();
    if (partnerData?.data && partnerData?.status === true) {
      setPartnerOptions(partnerData.data);
    }
  };

  const validateTitle = (value) => {
    if (value.trim() === "") {
      return "Title is required";
    } else {
      return "";
    }
  };

  const handleButtonClick = () => {
    if (editable) {
      setEditable(false);
    } else {
      handleDoneClick();
    }
  };

  const editNotification = () => {
    toast.warning("Click the Edit button to update Metadata.", {
      position: toast.POSITION.BOTTOM_RIGHT,
      autoClose: 2000,
    });
  };

  return (
    <div className="col-4 right-content">
      <div className="video-container VideoInfoBox">
        <div className="video-title">
          {videodata?.metadata == null
            ? videodata?.filename
            : videodata?.metadata?.title}
          <p className="small-grey-text">
            {videodata?.metadata == null
              ? null
              : "(" + videodata?.filename + ")"}
          </p>
        </div>
        <div className="allIcons">
        {permission === "edit" ? (
          featurecheck ? (
            <button className="image-container" style={{ marginLeft: "auto", display:"flex", justifyContent:"center", alignItems:"center" }} onClick={() => featuredchecks()}>
              <img src={check} className="image" alt="check" style={{ width:"24px" }} />
            </button>
          ) : (
            <button className="image-container" style={{ marginLeft: "auto", display:"flex", justifyContent:"center", alignItems:"center" }}  onClick={() => featuredchecks()}>
              <img src={uncheck} className="image" alt="uncheck" style={{ width:"24px" }}/>
            </button>
          )
        ) : null}
        {permission === "edit" ? (
          <>
            <button className="image-container" onClick={() => expandMetaView()}>
              <img src={OpenfullIcon} className="image" alt="openfullicon" />
            </button>
            <button
              className="image-container"
              style={{ marginLeft: "auto", position: "relative" }}
              onClick={() => handleButtonClick()}
              disabled={!editable}
            >
              <img src={editIcon} className="image" alt="edit" />
              <span style={{ position: "absolute", top: "19px", right: "-3px" }}>
                {!editable ? (
                  <img src={activeIcon} width={12} alt="activeicon"/>
                ) : (
                  <img src={crossCheck} width={12} alt="crosscheck"/>
                )}
              </span>
            </button>
          </>
        ) : null}
        <button className="image-container" onClick={() => closepartition()}>
          <img src={CloseIcon} className="image" alt="close"/>
        </button>
        </div>
      </div>
      <div className="part-height my-4">
        <div className="video-details">
          {xmlData.map((data, index) => (
            <div key={index} onClick={() => editable ? editNotification() : ''}>
              {data?.fields.map((data2, index2) => {
                if (data2?.type === "text" || data2?.type === "email" || data2?.type === "password" || data2.type === "color" || data2?.type === "file" || data2?.type === "checkbox" || data2?.type === "search") {
                  if (data2?.name === "title") {
                    return (
                      <div className="detail-row">
                        <div className="detail-label">Title<span style={{ color: "red" }}>*</span></div>
                        <input
                          className="detail-inputs"
                          readOnly={editable}
                          value={title}
                          onChange={(e) => setTitle(e.target.value)}
                        />
                      </div>
                    );
                  }
                  if (data2?.name === "programType") {
                    return (
                      <div className="detail-row">
                        <div className="detail-label">Program Type</div>
                        <input
                          className="detail-inputs"
                          readOnly={editable}
                          value={programType}
                          onChange={(e) => setProgramType(e.target.value)}
                        />
                      </div>
                    );
                  }
                 
if (data2?.name === "duration") {
  return (
    <div className="detail-row">
      <div className="detail-label">Duration</div>
      {/* <input
        className="detail-inputs"
        type="text" // Use text for custom formatting
        readOnly={editable}
        value={duration}
        onChange={(e) => {
          let value = e.target.value;
          // Remove any non-numeric or non-colon characters
          value = value.replace(/[^0-9:]/g, '');
          // Enforce HH:MM:SS format
          if (value.length <= 8) { // Max length for HH:MM:SS
            let formattedValue = value;
            // Auto-insert colons
            if (value.length > 2 && value[2] !== ':') {
              formattedValue = value.slice(0, 2) + ':' + value.slice(2);
            }
            if (value.length > 5 && value[5] !== ':') {
              formattedValue = formattedValue.slice(0, 5) + ':' + formattedValue.slice(5);
            }
            // Validate format (allow partial input during typing)
            if (formattedValue === '' || /^(\d{0,2}(:\d{0,2}(:\d{0,2})?)?)?$/.test(formattedValue)) {
              setDuration(formattedValue);
            }
          }
        }}
        placeholder="HH:MM:SS" // Guide user on format
        maxLength={8} // Max length for HH:MM:SS
      /> */}
      <TimePicker 
        className="detail-inputs duration"
        value={duration}
        disabled={editable}
        hourPlaceholder="HH"
        minutePlaceholder="MM"
        secondPlaceholder="SS"
        maxDetail="second"
        minTime="00:00:00"
        format="HH:mm:ss"
        onChange={(e) => {
            
           setDuration(e)
        }}
        disableClock={true}
    />
    </div>
  );
}
     

                  if (data2?.name === "ratingsDescriptor") {
                    return (
                      <div className="detail-row">
                        <div className="detail-label">Ratings Descriptor</div>
                        <input
                          className="detail-inputs"
                          readOnly={editable}
                          value={ratingsDescriptor}
                          onChange={(e) => setRatingsDescriptor(e.target.value)}
                        />
                      </div>
                    );
                  }
                  if (data2?.name === "actors") {
                    return (
                      <div className="detail-row">
                        <div className="detail-label">Actors</div>
                        <input
                          className="detail-inputs"
                          readOnly={editable}
                          value={actors}
                          onChange={(e) => setActors(e.target.value)}
                        />
                      </div>
                    );
                  }
                  if (data2?.name === "directors") {
                    return (
                      <div className="detail-row">
                        <div className="detail-label">Directors</div>
                        <input
                          className="detail-inputs"
                          readOnly={editable}
                          value={directors}
                          onChange={(e) => setDirectors(e.target.value)}
                        />
                      </div>
                    );
                  }
                } else if (data2?.type === "multiSelect") {
                  if (data2?.name === "genres") {
                    return (
                      <div className="detail-row">
                        <div className="detail-label" key={index2}>
                          {data2?.label}{data2?.required ? <span style={{ color: "red" }}>*</span> : ''}
                        </div>
                        <DynamicMultiSelect
                          editable={editable}
                          options={gernreList}
                          displayValue="name"
                          selectedValues={selectedGenreIds}
                          placeholder="Select Genre"
                          setSelectedCategoryIds={setSelectedGenreIds}
                          selectedCategoryIds={selectedGenreIds}
                        />
                      </div>
                    );
                  }
                  if (data2?.name === "themes") {
                    return (
                      <div className="detail-row">
                        <div className="detail-label">Themes</div>
                        <DynamicMultiSelect
                          editable={editable}
                          options={themeList}
                          displayValue="name"
                          selectedValues={selectedThemeIds}
                          placeholder="Select Theme"
                          setSelectedCategoryIds={setSelectedThemeIds}
                          selectedCategoryIds={selectedThemeIds}
                        />
                      </div>
                    );
                  }
                  if (data2?.name === "categories") {
                    return (
                      <div className="detail-row">
                        <div className="detail-label">Categories</div>
                        <DynamicMultiSelect
                          editable={editable}
                          options={categoryOptions}
                          displayValue="name"
                          selectedValues={selectedCategoryIds}
                          placeholder="Select Categories"
                          setSelectedCategoryIds={setSelectedCategoryIds}
                          selectedCategoryIds={selectedCategoryIds}
                        />
                      </div>
                    );
                  }
                  if (data2?.name === "audioLanguages") {
                    return (
                      <div className="detail-row">
                        <div className="detail-label">Audio Languages</div>
                        <DynamicMultiSelect
                          editable={editable}
                          options={languageList}
                          displayValue="name"
                          selectedValues={selectedLanguageIds}
                          placeholder="Select Language"
                          setSelectedCategoryIds={setSelectedLanguageIds}
                          selectedCategoryIds={selectedLanguageIds}
                        />
                      </div>
                    );
                  }
                  if (data2?.name === "territories") {
                    return (
                      <div className="detail-row">
                        <div className="detail-label">Territory</div>
                        <DynamicMultiSelect
                          editable={editable}
                          options={territoryOption}
                          displayValue="niceName"
                          selectedValues={selectedTerritoryIds}
                          placeholder="Select Territory"
                          setSelectedCategoryIds={setSelectedTerritoryIds}
                          selectedCategoryIds={selectedTerritoryIds}
                        />
                      </div>
                    );
                  }
                } else if (data2?.type === "select") {
                  if (data2?.name === "contentGroup") {
                    return (
                      <div className="detail-row">
                        <div className="detail-label">Content Group</div>
                        <CustomSingleSelect
                          options={ContentGroup?.map(item => ({ id: item, name: item }))}
                          value={contentGroup}
                          onChange={(value) => setContentGroup(value)}
                          placeholder="Select Content Group"
                          disabled={editable}
                          displayKey="name"
                          valueKey="id"
                        />
                      </div>
                    );
                  }
                  if (data2?.name === "ratings") {
                    return (
                      <div className="detail-row">
                        <div className="detail-label">Rating</div>
                        <CustomSingleSelect
                          options={ratingList}
                          value={ratingvalue}
                          onChange={(value) => {
                            setRating(value);
                            const selectedItem = ratingList.find(item => item.id === value);
                            if (!videodata?.metadata?.ratingsDescriptor) {
                              setRatingsDescriptor(selectedItem?.description || '');
                            }
                          }}
                          placeholder="Select Rating"
                          disabled={editable}
                          displayKey="name"
                          valueKey="id"
                        />
                      </div>
                    );
                  }
                  if (data2?.name === "originalLanguage") {
                    return (
                      <div className="detail-row">
                        <div className="detail-label">Original Language</div>
                        <CustomSingleSelect
                          options={languageList}
                          value={originalLanguage}
                          onChange={(value) => setOriginalLanguage(value)}
                          placeholder="Select Language"
                          disabled={editable}
                          displayKey="name"
                          valueKey="id"
                        />
                      </div>
                    );
                  }
                  if (data2?.name === "origin") {
                    return (
                      <div className="detail-row">
                        <div className="detail-label">Origin</div>
                        <CustomSingleSelect
                          options={territoryOption}
                          value={origin}
                          onChange={(value) => setOrigin(value)}
                          placeholder="Select Origin"
                          disabled={editable}
                          displayKey="niceName"
                          valueKey="niceName"
                        />
                      </div>
                    );
                  }
                } else if (data2?.type === "textarea") {
                  if (data2.name === "shortSynopsis") {
                    return (
                      <div className="detail-row col-12">
                        <div className="detail-label">Short Synopsis</div>
                        <textarea
                          className="detail-inputs dropdownScroll"
                          readOnly={editable}
                          value={shortSynopsis}
                          onChange={(e) => setShortSynopsis(e.target.value)}
                        />
                      </div>
                    );
                  }
                } else if (data2?.type === "date") {
                  if (data2.name === "releaseDate") {
                    return (
                      <div className="detail-row">
                        <div className="detail-label">Release Date</div>
                        <DatePicker
                          className="detail-inputs"
                          selected={releaseDate || null}
                          onChange={(date) => setReleaseDate(date)}
                          dateFormat="dd/MM/yyyy"
                          placeholderText="dd/mm/yyyy"
                          isClearable={permission}
                          readOnly={editable}
                        />
                      </div>
                    );
                  }
                  if (data2.name === "startDate") {
                    return (
                      <div className="detail-row">
                        <div className="detail-label">Start Date</div>
                        <DatePicker
                          className="detail-inputs"
                          selected={startDate || null}
                          onChange={(date) => setStartDate(date)}
                          dateFormat="dd/MM/yyyy"
                          placeholderText="dd/mm/yyyy"
                          isClearable
                          readOnly={editable}
                        />
                      </div>
                    );
                  }
                  if (data2.name === "endDate") {
                    return (
                      <div className="detail-row">
                        <div className="detail-label">End Date</div>
                        <DatePicker
                          className="detail-inputs"
                          selected={endDate || null}
                          onChange={(date) => setEndDate(date)}
                          dateFormat="dd/MM/yyyy"
                          placeholderText="dd/mm/yyyy"
                          isClearable
                          minDate={startDate}
                          disabled={!startDate}
                          readOnly={editable}
                        />
                      </div>
                    );
                  }
                }
                return null;
              })}
            </div>
          ))}
          <div>
            <button className="default-odd" onClick={() => closepartition()}>
              Cancel
            </button>
            {permission === "edit" ? (
              <button disabled={updatebtn} className="default-even mx-3" onClick={handleButtonClick}>
                {editable ? "Edit" : videodata?.metadata != null ? "Update" : "Add"}
              </button>
            ) : null}
          </div>
          <div></div>
        </div>
      </div>
    </div>
  );
})

export default Partitioncontent;